/* Rewind bundle widget.
   Tier cards -> the selected card expands with a colour + size picker per item
   -> one add to cart.

   Adds REAL product variants, so stock and the weekly workbook import keep
   working. The saving shown on each card is a preview; the money is taken off
   by the automatic discounts on the store (buy 2 -> 10%, buy 3 -> 20%). */
(function () {
  if (window.__rwBundleInit) return;
  window.__rwBundleInit = true;

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "en", {
        style: "currency",
        currency: currency || "AED",
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function parseTiers(raw) {
    return (raw || "")
      .split(",")
      .map(function (t) {
        var p = t.split(":");
        return { quantity: parseInt(p[0], 10), percentage: parseFloat(p[1]) || 0 };
      })
      .filter(function (t) {
        return t.quantity > 0;
      })
      .sort(function (a, b) {
        return a.quantity - b.quantity;
      });
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function setup(root) {
    var dataEl = root.querySelector("[data-rw-bundle-data]");
    if (!dataEl) return;

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    // Keep sold-out colours in the list rather than hiding them - Ziyad wants
    // the customer to see the full range and which colours are simply out.
    // They render greyed and disabled, so they still cannot be picked.
    var products = (data.products || []).filter(function (p) {
      return p.variants && p.variants.length;
    });
    if (!products.length) return;
    if (!products.some(function (p) {
      return p.variants.some(function (v) { return v.available; });
    })) return; // nothing buyable at all - show no widget

    var tiers = parseTiers(root.dataset.tiers);
    if (!tiers.length) return;

    var currency = root.dataset.currency || "AED";
    var highlight = parseInt(root.dataset.highlight, 10) || 0;
    var badgeText = root.dataset.badge || "";

    var tiersEl = root.querySelector("[data-rw-tiers]");
    var addBtn = root.querySelector("[data-rw-add]");
    var noteEl = root.querySelector("[data-rw-note]");

    var unitPrice = products[0].variants[0].price;
    var selected = null;
    var rows = [];

    // Socks (and anything else one-size) have a single variant per colour, so
    // a size dropdown would offer one meaningless choice. Drop the control
    // entirely and pick the only variant when the colour is chosen.
    var needsSize = products.some(function (p) { return p.variants.length > 1; });

    function tierLabel(tier) {
      return tier.quantity === 1 ? "1 Piece" : "Buy " + tier.quantity;
    }

    function tierOffer(tier) {
      return tier.percentage > 0 ? "SAVE " + tier.percentage + "%" : "Full price";
    }

    function selectTier(tier) {
      if (selected === tier) return;
      selected = tier;
      rows = [];
      for (var i = 0; i < tier.quantity; i++) rows.push({ product: null, variant: null });
      render();
    }

    function buildItemRow(row, idx) {
      var wrap = el("div", "rw-bundle__item");

      var thumb = el("span", "rw-bundle__thumb");
      var img = document.createElement("img");
      img.alt = "";
      img.width = 40;
      img.height = 50;
      img.loading = "lazy";
      if (row.product && row.product.image) img.src = row.product.image;
      thumb.appendChild(img);

      var colour = document.createElement("select");
      colour.className = "rw-bundle__select rw-bundle__select--colour";
      colour.setAttribute("aria-label", "Colour for item " + (idx + 1));
      var ph = new Option("Colour", "");
      ph.disabled = true;
      ph.selected = !row.product;
      colour.appendChild(ph);
      products.forEach(function (p) {
        var anyLeft = p.variants.some(function (v) { return v.available; });
        var o = new Option(anyLeft ? p.colour : p.colour + " (Sold out)", p.handle);
        o.disabled = !anyLeft;
        if (!anyLeft) o.className = "rw-bundle__opt--out";
        if (row.product && row.product.handle === p.handle) o.selected = true;
        colour.appendChild(o);
      });

      var size = document.createElement("select");
      size.className = "rw-bundle__select rw-bundle__select--size";
      size.setAttribute("aria-label", "Size for item " + (idx + 1));
      if (!row.product) {
        size.disabled = true;
        size.appendChild(new Option("Size", ""));
      } else {
        var sph = new Option("Size", "");
        sph.disabled = true;
        sph.selected = !row.variant;
        size.appendChild(sph);
        row.product.variants.forEach(function (v) {
          // How many OTHER rows already claim this exact variant? Without this
          // a customer can pick the same size three times when only two are in
          // stock, and Shopify silently drops the extras at /cart/add.js
          // ("Only 2 items were added due to availability").
          var claimed = rows.filter(function (r, i) {
            return i !== idx && r.variant && r.variant.id === v.id;
          }).length;
          var stock = typeof v.qty === "number" ? v.qty : 0;
          var exhausted = !v.oversell && stock > 0 && claimed >= stock;

          // Sizes carry no "(Sold out)" wording - Ziyad wants that only on the
          // colour. An unavailable size is simply greyed and unpickable.
          var o = new Option(v.size, String(v.id));
          o.disabled = !v.available || exhausted;
          if (o.disabled) o.className = "rw-bundle__opt--out";
          if (row.variant && row.variant.id === v.id) o.selected = true;
          size.appendChild(o);
        });
      }

      colour.addEventListener("change", function () {
        row.product = products.filter(function (p) { return p.handle === colour.value; })[0] || null;
        row.variant = null;
        // one-variant product (socks): nothing to ask, take it
        if (row.product && row.product.variants.length === 1 && row.product.variants[0].available) {
          row.variant = row.product.variants[0];
        }
        render();
      });
      size.addEventListener("change", function () {
        row.variant = row.product
          ? row.product.variants.filter(function (v) { return String(v.id) === size.value; })[0] || null
          : null;
        render();
      });

      wrap.appendChild(thumb);
      wrap.appendChild(colour);
      if (needsSize) wrap.appendChild(size);
      return wrap;
    }

    function render() {
      tiersEl.innerHTML = "";

      tiers.forEach(function (tier, i) {
        var each = Math.round(unitPrice * (1 - tier.percentage / 100));
        var isSel = selected === tier;

        var card = el("div", "rw-bundle__tier" + (isSel ? " is-selected" : ""));
        if (highlight === i + 1 && badgeText) {
          card.appendChild(el("span", "rw-bundle__badge", badgeText));
        }

        var head = el("button", "rw-bundle__tier-head");
        head.type = "button";
        head.setAttribute("aria-pressed", isSel ? "true" : "false");

        var radio = el("span", "rw-bundle__radio");
        var info = el("span", "rw-bundle__tier-info");
        info.appendChild(el("span", "rw-bundle__tier-name", tierLabel(tier)));
        if (tier.percentage > 0) {
          info.appendChild(el("span", "rw-bundle__chip", tierOffer(tier)));
        } else {
          info.appendChild(el("span", "rw-bundle__tier-sub", tierOffer(tier)));
        }

        var price = el("span", "rw-bundle__tier-price");
        price.appendChild(
          el(
            "span",
            "rw-bundle__price-now" + (tier.percentage > 0 ? " is-discounted" : ""),
            money(each, currency) + "/pcs"
          )
        );
        if (tier.percentage > 0) {
          price.appendChild(el("span", "rw-bundle__price-was", money(unitPrice, currency)));
        }

        head.appendChild(radio);
        head.appendChild(info);
        head.appendChild(price);
        head.addEventListener("click", function () { selectTier(tier); });
        card.appendChild(head);

        if (isSel) {
          var body = el("div", "rw-bundle__tier-body");
          body.appendChild(el("p", "rw-bundle__picker-label", "Colour, Size"));
          rows.forEach(function (row, idx) {
            body.appendChild(buildItemRow(row, idx));
          });
          card.appendChild(body);
        }

        tiersEl.appendChild(card);
      });

      var chosen = rows.filter(function (r) { return r.variant; });
      var need = selected ? selected.quantity - chosen.length : 0;
      addBtn.disabled = !selected || need > 0;
      noteEl.textContent = !selected
        ? ""
        : need > 0
        ? "Choose " + need + " more"
        : "Discount applied at checkout";
    }

    var busy = false;

    addBtn.addEventListener("click", function () {
      if (busy) return;
      var chosen = rows.filter(function (r) { return r.variant; });
      if (!selected || chosen.length < selected.quantity) return;

      busy = true;
      addBtn.disabled = true;
      addBtn.classList.add("is-loading");
      noteEl.textContent = "Adding…";

      var base =
        (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

      // Ask for the cart drawer's sections in the SAME request. Dawn can then
      // repaint the drawer from this one response - no second fetch, and no
      // page navigation, which is what made the old version feel dead on the
      // first click.
      var drawer = document.querySelector("cart-drawer");
      var canRender =
        drawer &&
        typeof drawer.renderContents === "function" &&
        typeof drawer.getSectionsToRender === "function";

      var payload = {
        items: chosen.map(function (r) { return { id: r.variant.id, quantity: 1 }; }),
      };
      if (canRender) {
        try {
          payload.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
          payload.sections_url = window.location.pathname;
        } catch (e) {
          canRender = false;
        }
      }

      fetch(base + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(payload),
      })
        .then(function (r) {
          return r.json().then(function (b) { return { ok: r.ok, body: b }; });
        })
        .then(function (res) {
          if (!res.ok) {
            throw new Error((res.body && res.body.description) || "Could not add to cart");
          }

          if (canRender) {
            drawer.renderContents(res.body);

            // The drawer is rendered with an "is-empty" class when the page
            // loads with an empty cart, and Dawn's renderContents only clears
            // it from .drawer__inner - not from the <cart-drawer> host. Leave
            // it and the line items render but stay hidden by CSS: the
            // customer sees a blank panel with only a total. Clear it on both.
            drawer.classList.remove("is-empty");
            var inner = drawer.querySelector(".drawer__inner");
            if (inner) inner.classList.remove("is-empty");

            document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
            busy = false;
            addBtn.disabled = false;
            addBtn.classList.remove("is-loading");
            noteEl.textContent = "Added to cart";
          } else {
            window.location.href = base + "cart";
          }
        })
        .catch(function (err) {
          busy = false;
          addBtn.disabled = false;
          addBtn.classList.remove("is-loading");
          noteEl.textContent = err.message || "Could not add to cart. Please try again.";
        });
    });

    if (highlight >= 1 && highlight <= tiers.length) selectTier(tiers[highlight - 1]);
    else render();
  }

    /* ---------------------------------------------------------------
     Set builder: exactly one item from each of two collections.
     Shares CSS, money(), el() and the cart/drawer logic with the
     bundle widget above.
     --------------------------------------------------------------- */
  function setupSet(root) {
    var dataEl = root.querySelector("[data-rw-set-data]");
    if (!dataEl) return;

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var groups = (data.groups || []).map(function (g) {
      return {
        label: g.label,
        products: (g.products || []).filter(function (p) {
          return p.variants && p.variants.length;
        })
      };
    });
    if (groups.length < 2) return;

    // every group needs something sellable or the set can never be completed
    var sellable = groups.every(function (g) {
      return g.products.some(function (p) {
        return p.variants.some(function (v) { return v.available; });
      });
    });
    if (!sellable) return;

    var pct = Number(data.discount) || 0;
    // A pack draws every row from ONE collection, so two rows can land on the
    // same variant and the wording is "choose 2 more", not "choose a shirt".
    var isPack = data.pack === true;
    var currency = root.dataset.currency || "AED";
    var rowsEl = root.querySelector("[data-rw-set-rows]");
    var totals = root.querySelector("[data-rw-set-totals]");
    var wasEl = root.querySelector("[data-rw-set-was]");
    var nowEl = root.querySelector("[data-rw-set-now]");
    var saveEl = root.querySelector("[data-rw-set-save]");
    var addBtn = root.querySelector("[data-rw-set-add]");
    var noteEl = root.querySelector("[data-rw-set-note]");

    var picks = groups.map(function () { return { product: null, variant: null }; });
    var busy = false;

    function renderSet() {
      rowsEl.innerHTML = "";

      groups.forEach(function (group, gi) {
        var pick = picks[gi];
        var needsSize = group.products.some(function (p) { return p.variants.length > 1; });

        var wrap = el("div", "rw-bundle__item");

        var thumb = el("span", "rw-bundle__thumb");
        var img = document.createElement("img");
        img.alt = "";
        img.width = 40;
        img.height = 50;
        img.loading = "lazy";
        if (pick.product && pick.product.image) img.src = pick.product.image;
        thumb.appendChild(img);

        var label = el("span", "rw-set__label", group.label);

        var colour = document.createElement("select");
        colour.className = "rw-bundle__select rw-bundle__select--colour";
        // a set names its groups ("Shirt"), a pack just numbers them - "1" is a
        // poor placeholder, so packs say "Colour" like the bundle widget does
        colour.setAttribute("aria-label",
          (isPack ? "Item " + group.label : group.label) + " colour");
        var ph = new Option(isPack ? "Colour" : group.label, "");
        ph.disabled = true;
        ph.selected = !pick.product;
        colour.appendChild(ph);
        group.products.forEach(function (p) {
          var anyLeft = p.variants.some(function (v) { return v.available; });
          var o = new Option(anyLeft ? p.colour : p.colour + " (Sold out)", p.handle);
          o.disabled = !anyLeft;
          if (!anyLeft) o.className = "rw-bundle__opt--out";
          if (pick.product && pick.product.handle === p.handle) o.selected = true;
          colour.appendChild(o);
        });
        colour.addEventListener("change", function () {
          pick.product = group.products.filter(function (p) {
            return p.handle === colour.value;
          })[0] || null;
          pick.variant = null;
          if (pick.product && pick.product.variants.length === 1 && pick.product.variants[0].available) {
            pick.variant = pick.product.variants[0];
          }
          renderSet();
        });

        var size = document.createElement("select");
        size.className = "rw-bundle__select rw-bundle__select--size";
        size.setAttribute("aria-label",
          (isPack ? "Item " + group.label : group.label) + " size");
        if (!pick.product) {
          size.disabled = true;
          size.appendChild(new Option("Size", ""));
        } else {
          var sph = new Option("Size", "");
          sph.disabled = true;
          sph.selected = !pick.variant;
          size.appendChild(sph);
          pick.product.variants.forEach(function (v) {
            // How many OTHER rows already claim this exact variant? Without this
            // a pack can take the same size three times when only two are in
            // stock, and Shopify silently drops the extras at /cart/add.js.
            var claimed = picks.filter(function (r, i) {
              return i !== gi && r.variant && r.variant.id === v.id;
            }).length;
            var stock = typeof v.qty === "number" ? v.qty : 0;
            var exhausted = !v.oversell && stock > 0 && claimed >= stock;

            var o = new Option(v.size, String(v.id));
            o.disabled = !v.available || exhausted;
            if (o.disabled) o.className = "rw-bundle__opt--out";
            if (pick.variant && pick.variant.id === v.id) o.selected = true;
            size.appendChild(o);
          });
        }
        size.addEventListener("change", function () {
          pick.variant = pick.product
            ? pick.product.variants.filter(function (v) { return String(v.id) === size.value; })[0] || null
            : null;
          renderSet();
        });

        wrap.appendChild(thumb);
        wrap.appendChild(label);
        wrap.appendChild(colour);
        if (needsSize) wrap.appendChild(size);
        rowsEl.appendChild(wrap);
      });

      var chosen = picks.filter(function (p) { return p.variant; });
      var full = chosen.reduce(function (sum, p) { return sum + p.variant.price; }, 0);
      var complete = chosen.length === groups.length;
      var total = complete ? Math.round(full * (1 - pct / 100)) : full;

      // The price row is optional - this page shows the set price under the
      // product title instead, so these nodes are simply absent.
      if (totals) totals.hidden = chosen.length === 0;
      if (wasEl) wasEl.textContent = complete && pct ? money(full, currency) : "";
      if (nowEl) nowEl.textContent = money(total, currency);
      if (saveEl) {
        saveEl.textContent =
          complete && pct ? "Save " + money(full - total, currency) + " (" + pct + "%)" : "";
      }

      addBtn.disabled = !complete;
      if (complete) {
        noteEl.textContent = isPack
          ? "Discount applied at checkout"
          : "Set discount applied at checkout";
      } else if (isPack) {
        var left = groups.length - chosen.length;
        noteEl.textContent = "Choose " + left + " more";
      } else {
        var missing = groups
          .map(function (g, i) { return picks[i].variant ? null : g.label.toLowerCase(); })
          .filter(Boolean);
        noteEl.textContent = "Select your " + missing.join(" and ");
      }
    }

    addBtn.addEventListener("click", function () {
      if (busy) return;
      var chosen = picks.filter(function (p) { return p.variant; });
      if (chosen.length !== groups.length) return;

      busy = true;
      addBtn.disabled = true;
      addBtn.classList.add("is-loading");
      noteEl.textContent = "Adding…";

      var base =
        (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
      var drawer = document.querySelector("cart-drawer");
      var canRender =
        drawer &&
        typeof drawer.renderContents === "function" &&
        typeof drawer.getSectionsToRender === "function";

      var payload = {
        items: chosen.map(function (p) { return { id: p.variant.id, quantity: 1 }; })
      };
      if (canRender) {
        try {
          payload.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
          payload.sections_url = window.location.pathname;
        } catch (e) {
          canRender = false;
        }
      }

      fetch(base + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(payload)
      })
        .then(function (r) {
          return r.json().then(function (b) { return { ok: r.ok, body: b }; });
        })
        .then(function (res) {
          if (!res.ok) {
            throw new Error((res.body && res.body.description) || "Could not add to cart");
          }
          if (canRender) {
            drawer.renderContents(res.body);
            drawer.classList.remove("is-empty");
            var inner = drawer.querySelector(".drawer__inner");
            if (inner) inner.classList.remove("is-empty");
            busy = false;
            addBtn.disabled = false;
            addBtn.classList.remove("is-loading");
            noteEl.textContent = "Added to cart";
          } else {
            window.location.href = base + "cart";
          }
        })
        .catch(function (err) {
          busy = false;
          addBtn.disabled = false;
          addBtn.classList.remove("is-loading");
          noteEl.textContent = err.message || "Could not add to cart. Please try again.";
        });
    });

    renderSet();
  }

  function init() {
    // A set root carries BOTH data-rw-bundle (for the shared CSS) and
    // data-rw-set, so exclude it here or setup() would try to read tiers it
    // does not have.
    document.querySelectorAll("[data-rw-bundle]:not([data-rw-set])").forEach(function (n) {
      if (!n.__rwInit) {
        n.__rwInit = true;
        setup(n);
      }
    });
    document.querySelectorAll("[data-rw-set]").forEach(function (n) {
      if (!n.__rwInit) {
        n.__rwInit = true;
        setupSet(n);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  document.addEventListener("shopify:section:load", init);
})();
